// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-2b89364a]::-webkit-inner-spin-button,input[data-v-2b89364a]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-2b89364a]{-moz-appearance:textfield}", ""]);
// Exports
module.exports = exports;
